import { supabase } from './supabase'

// Invoca una Edge Function con el JWT de la sesión actual y devuelve el mensaje
// de error del backend (p. ej. "Ya existe un usuario…") en lugar del genérico de supabase-js.
export async function invokeEdgeFunction(name, body) {
  const { data, error } = await supabase.functions.invoke(name, { body })
  if (error) {
    let message = 'No fue posible completar la operación.'
    try {
      const payload = await error.context?.json?.()
      if (payload?.error) message = payload.error
    } catch { /* respuesta sin JSON */ }
    const failure = new Error(message)
    failure.status = error.context?.status
    throw failure
  }
  return data
}
